module.exports = __webpack_public_path__ + "src/assets/img/share/tips/conscientiousness/e7c1232f690e339de2a2a8f81c270d3e.png";